"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customTakeLatest = void 0;

var cancelable = function cancelable(promise) {
  var hasCancelled = false;
  return {
    promise: new Promise(function (resolve, reject) {
      promise.then(function (result) {
        if (hasCancelled) {
          reject(new Error('Promise rejected'));
        }

        resolve(result);
        return;
      });
    }),
    cancel: function cancel() {
      hasCancelled = true;
    }
  };
};

var createTakeLatest = function createTakeLatest() {
  var cancelablePromise = null;

  var takeLatest = function takeLatest(promise) {
    if (cancelablePromise) {
      cancelablePromise.cancel();
    }

    cancelablePromise = cancelable(promise);
    return cancelablePromise.promise;
  };

  return takeLatest;
};

var customTakeLatest = createTakeLatest();
exports.customTakeLatest = customTakeLatest;